export const ExperienceIcon = ({ primaryFontColor = '#ffd800' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="suitcase"
        d="M18.135,8.009H15.259v-.7a1.453,1.453,0,0,0-1.451-1.451H10.192A1.453,1.453,0,0,0,8.741,7.307v.7H5.865a.925.925,0,0,0-.924.924v1.785c0,.009,0,.018,0,.028a.135.135,0,0,0,0,.014v5.407A2.078,2.078,0,0,0,7.1,18.143h9.8a2.078,2.078,0,0,0,2.161-1.977V10.787c0-.008,0-.015,0-.023s0-.03,0-.046V8.933a.925.925,0,0,0-.924-.924Zm-8.644-.7a.7.7,0,0,1,.7-.7h3.617a.7.7,0,0,1,.7.7v.7H9.491Zm-3.8,1.626a.176.176,0,0,1,.174-.174H18.135a.177.177,0,0,1,.174.174v1.785a1.962,1.962,0,0,1-1.96,1.96H13.778v-.761a.375.375,0,0,0-.375-.375H10.6a.375.375,0,0,0-.375.375v.761H7.651a1.962,1.962,0,0,1-1.96-1.96V8.933Zm7.337,3.359V13.68H10.972V12.291Zm5.28,3.875A1.33,1.33,0,0,1,16.9,17.393H7.1a1.33,1.33,0,0,1-1.411-1.227V12.587a2.7,2.7,0,0,0,1.96.841h2.571v.628a.375.375,0,0,0,.375.375H13.4a.375.375,0,0,0,.375-.375v-.628h2.571a2.7,2.7,0,0,0,1.96-.841v3.58ZM12,0A12,12,0,1,1,0,12,12.014,12.014,0,0,1,12,0Z"
        fill={primaryFontColor}
        fill-rule="evenodd"
      />
    </svg>
  );
};
